module.exports = __webpack_public_path__ + "static/media/47.e327f869.jpg";